import { __assign, __awaiter, __generator } from "tslib";
import { parse } from 'cookie';
import { axios } from '../utils/axios';
import { getUach } from './utils';
function postEventLogs(data, _a) {
    var eventLoggerUrl = _a.eventLoggerUrl, eventLoggerApiKey = _a.eventLoggerApiKey;
    return __awaiter(this, void 0, void 0, function () {
        var _b, Ra, Rp, Rz, uachData, jsonResponse;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = parse(document.cookie), Ra = _b.Ra, Rp = _b.Rp, Rz = _b.Rz;
                    return [4 /*yield*/, getUach()];
                case 1:
                    uachData = _c.sent();
                    return [4 /*yield*/, axios.post(eventLoggerUrl, [__assign(__assign(__assign({}, data), uachData), { Ra: Ra, Rp: Rp, Rz: Rz, source: 'jssdk' })], {
                            headers: {
                                'Content-Type': 'application/json',
                                'x-client-apikey': eventLoggerApiKey,
                            },
                        })];
                case 2:
                    jsonResponse = _c.sent();
                    return [2 /*return*/, jsonResponse.data];
            }
        });
    });
}
export function logToAPI(_a) {
    var _b = _a.screen, screen = _b === void 0 ? 'EMPTY' : _b, _c = _a.action, action = _c === void 0 ? 'EMPTY' : _c, _d = _a.version, version = _d === void 0 ? '' : _d, _e = _a.projectKey, projectKey = _e === void 0 ? '' : _e, _f = _a.userId, userId = _f === void 0 ? '' : _f, _g = _a.sessionId, sessionId = _g === void 0 ? '' : _g, _h = _a.domainScopedSessionId, domainScopedSessionId = _h === void 0 ? '' : _h, _j = _a.clientId, clientId = _j === void 0 ? '' : _j, _k = _a.isMobile, isMobile = _k === void 0 ? false : _k, campaignId = _a.campaignId, contentId = _a.contentId, _l = _a.message, message = _l === void 0 ? '' : _l, correlationId = _a.correlationId, selector = _a.selector, replacementId = _a.replacementId, impressionId = _a.impressionId, _m = _a.pageUrl, pageUrl = _m === void 0 ? '' : _m, _o = _a.eventLoggerUrl, eventLoggerUrl = _o === void 0 ? '' : _o, _p = _a.eventLoggerApiKey, eventLoggerApiKey = _p === void 0 ? '' : _p, _q = _a.isPreview, isPreview = _q === void 0 ? false : _q;
    return __awaiter(this, void 0, void 0, function () {
        var screenProductPrefix, logData, e_1;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0:
                    _r.trys.push([0, 2, , 3]);
                    screenProductPrefix = [projectKey, screen].join('_');
                    logData = __assign({ screen: screenProductPrefix, action: action, version: version, campaignId: campaignId, contentId: contentId, message: message, isMobile: isMobile, userId: userId, sessionId: sessionId, domainScopedSessionId: domainScopedSessionId, clientId: clientId, correlationId: correlationId, selector: selector, replacementId: replacementId, impressionId: impressionId, pageUrl: pageUrl }, (isPreview ? { isPreview: isPreview } : {}));
                    return [4 /*yield*/, postEventLogs(logData, { eventLoggerUrl: eventLoggerUrl, eventLoggerApiKey: eventLoggerApiKey })];
                case 1:
                    _r.sent();
                    return [2 /*return*/, logData];
                case 2:
                    e_1 = _r.sent();
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
